import { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonButton,
  IonItem,
  IonList,
  IonNote,
  IonLabel,
  IonBadge,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
} from '@ionic/react';

import { getEmployees, saveEmployee } from '@/actions/employees';
import { employeesSelector } from '@/selectors/employees';
import { requireRole } from '@/helpers/permissions';
import useResourceLoader from '@/hooks/useResourceLoader';
import LoadingPage from '@/pages/LoadingPage';
import Page from '@/pages/Page';


export default requireRole('owner', EmployeesPage);

function EmployeesPage({currentUser}) {
  const dispatch = useDispatch();
  const employees = useSelector(employeesSelector);
  const initialLoading = useResourceLoader(getEmployees());
  const listRef = useRef();

  if (initialLoading) return <LoadingPage />;

  const activate = (employee, active) => async (e) => {
    await dispatch(saveEmployee({uuid: employee.uuid, active, role: employee.role}));
    listRef.current?.closeSlidingItems();
  };

  return (
    <Page title="Employees" primaryButton={<IonButton routerLink="/employees/new">New</IonButton>}>
      <IonList ref={listRef}>
        {employees?.map((employee) => (
          <IonItemSliding key={employee.uuid} disabled={currentUser.uuid === employee.uuid}>
            <IonItem routerLink={`/employees/${employee.uuid}/edit`}>
              <IonLabel>
                <h2>
                  {employee.name}
                  {!employee.active && (
                    <IonBadge color="medium" className="ion-margin-start">disabled</IonBadge>
                  )}
                  {employee.invitation_status && employee.invitation_status != "accepted" && (
                    <IonBadge color="tertiary" className="ion-margin-start">invitation {employee.invitation_status}</IonBadge>
                  )}
                </h2>
                <p>{employee.phone_number}</p>
              </IonLabel>
              <IonNote slot="end">{employee.role}</IonNote>
            </IonItem>
            <IonItemOptions>
              {employee.active ? (
                <IonItemOption color="danger" onClick={activate(employee, false)}>Deactivate</IonItemOption>
              ) : (
                <IonItemOption color="secondary" onClick={activate(employee, true)}>Reactivate</IonItemOption>
              )}
            </IonItemOptions>
          </IonItemSliding>
        ))}
      </IonList>
    </Page>
  );
}
